import ButtonBox from "../main/form/ButtonBox";
import Button from "../main/form/Button";
import TosAcceptComponent from "./TosAcceptComponent";
import { TermsOfServiceResponse } from "types/v1/system/termsOfServiceResponse";
import { useContext, useEffect, useState } from "react";
import { APIHandlerContext, UserInfoContext } from "GlobalContextProviders";
import { TermsOfServiceAcceptance } from "types/v1/system/termsOfServiceAcceptance";
import { TermsOfServiceAcceptanceResponse } from "types/v1/system/termsOfServiceAcceptanceResponse";
import { UserTermsOfServiceResponse } from "types/v1/system/userTermsOfServiceResponse";
import { BuyerAdmin, BuyerUser, DiversityAdmin, DiversityUser, MemberAdmin, MemberUser, SuperAdmin, SuperUser, VendorUser, VendorUserAdmin } from "types/v1/system/userType";
import { B2GnowSystemFeature } from "types/v1/system/systemFeatureType";
import 'assets/v1/css/module/termsOfService/termsOfService.css'

const TosAlertContentComponent = () => {
	const [termsOfService, setTermsOfService] = useState<UserTermsOfServiceResponse | null>(null)
	const [tosFlags, setTosFlags] = useState<Array<TermsOfServiceResponse>>([]);
	const b2gAPI = useContext(APIHandlerContext);
	const userInfo = useContext(UserInfoContext);

	const acceptanceCallback = (accpetance: TermsOfServiceResponse) => {
		let tosFlagsShallow = [...tosFlags]
		let index = tosFlagsShallow.findIndex(item => item.termsOfServiceId == accpetance.termsOfServiceId);
		if (index !== -1) {
			tosFlagsShallow[index] = accpetance;
		}
		setTosFlags(tosFlagsShallow);
	}

	function getRandomInt(min: number, max: number): number {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	const generateURL = () => {
		let url: string = "";
		let xId : string = String(getRandomInt(0,9999)).padStart(4,'0');
		switch(userInfo?.userTypeId) {
			// 2025-04-10 only vendors should even make it here
			case VendorUser.userTypeId:
			case VendorUserAdmin.userTypeId:
				url = '/FrontPage/VendorMain.asp'
				break;
			case BuyerAdmin.userTypeId:
			case BuyerUser.userTypeId:
				url = '/FrontPage/BuyerMain.asp'
				break;
			case SuperAdmin.userTypeId:
			case SuperUser.userTypeId:
				url = '/Administrator/ACP/ACPMain.asp'
				break;
			case DiversityAdmin.userTypeId:
			case DiversityUser.userTypeId:
				url = '/FrontPage/StaffMain.asp'
				break;
			case MemberAdmin.userTypeId:
			case MemberUser.userTypeId:
				// members are not configured
				// matching logic here is not needed
				break;
		}

		return `${url}?XID=${xId}`;
	}

	useEffect(() => {
		if (userInfo?.vendorId) {
			let systemFeatureTypeId: number = B2GnowSystemFeature.systemFeatureTypeId;
			let path = `/TOS/${userInfo?.vendorId}/${systemFeatureTypeId}`;
			b2gAPI.getTyped<UserTermsOfServiceResponse>(
				path,
				(response) => {
					let transformedData = {...response};
					transformedData.systemFeatureTermsOfService = response.systemFeatureTermsOfService?.filter(tos => tos.dateAccepted == null);
					setTermsOfService(transformedData);
					setTosFlags(transformedData.systemFeatureTermsOfService.map(r => r.termsOfServiceResponse));
				}
			)
		}
	}, [b2gAPI, userInfo?.vendorId])

	const acceptTermsOfService = () => {
		let path = "/TOS/multiple";

		let acceptanceData: Array<TermsOfServiceAcceptance> = tosFlags.map<TermsOfServiceAcceptance>(r => {
			return {
				identifier: 0,
				userId: userInfo?.userId!,
				termsOfServiceId: r.termsOfServiceId,
				override: false,
				vendorId: termsOfService?.vendorId!,
				accepted: (r.dateAccepted != null && r.dateAccepted < new Date()),
				ipAddress: "",
				userAgent: ""
			}
		})

		b2gAPI.postTyped<Array<TermsOfServiceAcceptance>, TermsOfServiceAcceptanceResponse>(
			path,
			acceptanceData,
			(_: TermsOfServiceAcceptanceResponse) => {
				window.location.href = generateURL()
			}
		)
	}

	return (
		<>
			<div className="tosAcceptanceBox">
				<h1 className="tosText tosColor">Review and Confirm To Continue</h1>
				<div className="tosText">
					To continue, please review and accept the following:
				</div>
				<div className="tosLinkColor tosCheckBoxes">
				{termsOfService?.systemFeatureTermsOfService.map(r => {
					return (
						<div style={{padding: ".4rem"}}>
							<TosAcceptComponent tos={r.termsOfServiceResponse} acceptCallback={acceptanceCallback}></TosAcceptComponent>
						</div>
					)
				}
				)}
				</div>

			</div>
			<ButtonBox>
				<Button label="Decline And Log Out" onClick={() => window.location.href = '/FrontPage/LogOff.asp'} />
				<Button label="Continue" onClick={() => acceptTermsOfService()}
					disabled={tosFlags.filter(r => r.dateAccepted == null).length > 0 || tosFlags.length == 0} />
			</ButtonBox>
		</>
	)
}

export default TosAlertContentComponent;